import React from 'react';
import { Code } from 'react-content-loader';
import { isBlank } from 'utils/storeUtils';


const SkeletonBatchLoader = (props) => {
  const { game, isRestartGame } = props;
  if (!isBlank(game) && !isRestartGame) return null;

  return (
    <>
      {Array.from(Array(2).keys()).map(i => (
        <div key={i} className={'mb-2'}>
          <Code
            key={`i-${i}`}
            backgroundColor="#696969"
            foregroundColor="#a9a9a9"
          />
        </div>
      ))}
    </>
  );
};

export default SkeletonBatchLoader;
